import React, {useContext, useEffect} from "react";
import Column from "@amzn/meridian/column";
import helpTokens from "@amzn/meridian-tokens/base/icon/help";
import {TopNavigationView, HelpView, Loader} from "@amzn/dolphin-uiweb-framework";
import {AppNavigationContext} from "./context/AppNavigationContext";
import help_icon from "../../images/ic_help_coming_up.png"
import {
    clearBackPressedEventListener,
    setBackPressedEventListener
} from "../../handler/BackPress";
import Alert from "../commons/Alert";
import {countIndexedDb} from "../network/IndexedDbUtility";
import {Logger} from "@amzn/dolphin-web-framework";
import {updateAlert} from "../../utils/utils";
import {NOTIFICATION_STRING} from "../../constants/constants";
import {FormattedMessage, injectIntl} from "react-intl";
import {ContainerPlanContext} from "../containerPlan/context/ContainerPlanContext";
import {ApplicationActions} from "../containerPlan/action/ApplicationActions";

/**
 * App Navigation components contains the global components for this
 * app which can be accessed from any components in the hierarchy
 * to control Help View, back button behaviour, Loader and Alerts
 */
const AppNavigation = (props) => {

    const {navState, navActions} = useContext(AppNavigationContext);
    // eslint-disable-next-line
    const {stateContainerPlan, dispatchContainerPlan} = useContext(ContainerPlanContext);

    /**
     * Callback to be called when system back press is called or
     * UI back button/close buttons are pressed to maintain
     * parity in behaviour.
     */
    const onBackPressed = React.useCallback((event) => {
        if (navState.helpOptions.open) {
            navActions.closeHelp();
        } else if (navState.onBackClicked) {
            countIndexedDb().then((size) => {
                if(size === 0) {
                    dispatchContainerPlan({type: ApplicationActions.BACK_SELECTED});
                    navState.onBackClicked.call(event);
                } else {
                    updateAlert(navActions, "warning", <FormattedMessage id={NOTIFICATION_STRING.ALERT_WARNING_DATA_SYNCING}/>);
                }
            }).catch((err) => {
                Logger.log.info("Error occurred while fetching size of indexeddb", err);
                navState.onBackClicked.call(event);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navState.onBackClicked, navState.helpOptions]);

    /**
     * Listeners are initialized for system back press events
     * but won't intercept unless explicitly started
     */
    useEffect(() => {
        setBackPressedEventListener(onBackPressed);
        return clearBackPressedEventListener;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navState.onBackClicked, navState.helpOptions]);

    /**
     * Top Navigation Bar, Help View, Loader and Alerts are common
     * throughout the apps and can be controlled via navActions
     */
    return (
        <Column spacing="small">
            {/* Global transparent loader overlay */}
            {navState.loading && <Loader/>}

            {/* Top Navigation Bar with Help and Back Button */}
            <TopNavigationView
                title={navState.title}
                backgroundType={navState.navType}
                onMenuButtonClicked={onBackPressed}
                optionsMenu={navState.helpEnabled ? [{
                    icon: helpTokens, onClick: navActions.openHelp
                }] : []}/>

            {/* Help View Overlay */}
            {navState.helpOptions.open && <HelpView
                onClose={() => window.history.back()}
                title={navState.helpOptions.title}
                pageTitle={navState.helpOptions.pageTitle}
                list={navState.helpOptions.list}
                help_icon={help_icon}/>}

            {/* Alerts */}
            {navState.alert.show && <Alert
                type={navState.alert.type}
                message={navState.alert.message}
                onClose={navState.alert.onClose}/>}
        </Column>
    );
}

export default injectIntl(AppNavigation)